<template lang="pug">
  .app-wrapper
    Nav
    .main-container
      SideBar
      Main
</template>

<script>
import SideBar from './SideBar'
import Nav from './Nav'
import Main from './Main'
export default {
  name: 'layout',
  components: {
    SideBar,
    Nav,
    Main,
  },
}
</script>

<style lang="scss" scoped>
 .main-container {
   width: 100%;
   height: calc(100vh + 100px);
  //  height: calc(100vh - 60px);
  //  overflow-y: scroll;
   margin-top: 60px;
   display: flex;
 }
</style>
